module.exports = __webpack_public_path__ + "img/welcome1.afd025bb.gif";